export default __webpack_public_path__ + "static/media/17.ec503e3c.jpg";